Property_id_search = {
	init : function(){
		// Check if region search elements are on page.
		//if( jQuery( '[name="property_select"]' ).size() == 0 )
		if( jQuery( '[data-oc-id="property-select-ajax"]' ).size() == 0 )
		{
			return false;
		}
		
		// Get data.
		var url = 'library/property/services/property-list.php';
		var config = new Object();
		config.cache = true;
		config.sort = 'alphabetical';
		config.order = 'asc';
		//options.abn = sh__site_object.property_options.client.abn;
		//options.license_1 = sh__site_object.property_options.client.sh_licence_1;
		//options.property_type = 'holiday';
		config.properties_per_page = 0; // We want the full list for the selects.
		var data_options = {};
		data_options.action = 'oc_property_list';
		//data_options.include_html = true;
		data_options.options = config;
		
		// Assemble options for Property Service.
		var ps_config = {};
		ps_config.queue_id = 'full-property-list';
		ps_config.client = 'property-id-search-field';
		ps_config.end_point = 'getProperties';
		
		// Calls.
		//Property_service_oncloud.get_data(url, config);
		//Property_service_oncloud.get_aa_data('oc_property_list',data_options);
		Property_service.get_data(ps_config);
		
		// Respond to AJAX property list data received.
		jQuery(document).on('oc_property_service_oc_data_retrieval',function(event,response){
			// Retrieve the required parameters.
			let properties = response.data.properties;
			// Set UI elements.
			//Property_id_search.init_ui(properties);
		});
		
		jQuery(document).on('oc_property_service_oc_data_retrieval_aa',function(event,response){
			//console.log('PROPERTY LIST AA: ',response);
			
			// Retrieve the required parameters.
			let properties = response.data.property_list.properties;
			
			// Set UI elements.
			//Property_id_search.init_ui(properties);
		});
		
		// Respond to AJAX property list data received.
		jQuery(document).on('oc_property_sort_submit_before',function(event,pm_options){
			//return(false);
			//console.log('PROPERTY SUBMIT',pm_options);
		});
		
		// Respond to Data retrieval from PROPERTY SERVICE.
		jQuery(document).on('property_service_data_retrieval',function(event,response){
			console.log('PROPERTY SERVICE DATA RETREIVED FOR PROPERTY ID FIELD: ',response);
			// Retrieve the required parameters.
			let properties = response.data.properties.holiday;
			// Set UI elements.
			Property_id_search.init_ui(properties);
		});	
	}
	,
	init_ui : function( properties )
	{
		var options_array = [];
		var option_index = 1;
		
		// Turn off loading text.
		jQuery('select[name="property_select"] option[value=""]').text('All Properties');
					
		for(property in properties)
		{
			var property_id = properties[property].uniqueID; //property_id;
			var title = properties[property].title;
			//console.log('PROPERTY',property_id);
							
			options_array.push( { id: property_id, text: title } );
			option_index++;
		}
				
		//options_array.sort();
						
		jQuery('select[name="property_select"]').select2({
			data: options_array,
			theme: 'bootstrap4',
			width: '100%',
		});
		
		jQuery('select[name="property_select"]').on('select2:select', function (e) {
			var data = e.params.data;
			
			// Set the Property ID hidden field.
			jQuery('[name="property_id"]').val( data.id );
			
			// Set the action for the form.
			if( data.id == '' ) // Stay on the Properties page
			{
				jQuery('#property-list-search').attr('action','/properties/');
			}
			else // Go to the Property Detail page.
			{
				jQuery('#property-list-search').attr('action','/property/?property_id=' + data.id);
			}
		});
		
		var current_property = jQuery('select[name="property_select"]').parent().attr('data-current-property');
		jQuery('select[name="property_select"] option').each(function(pm_index){
			//console.log('Check region select: ', current_suburb, jQuery(this).text());
		});
		
		jQuery('select[name="property_select"]').val(current_property);
		jQuery('select[name="property_select"]').trigger('change');
	}
}

jQuery(document).ready(function(jQuery){
	Property_id_search.init();
});